import ja from 'vuetify/lib/locale/ja'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 閉じる
export default {
  ...ja,
  __General: {
    submit: '送信'
  },
  __InitialLoading: {
    connecting: '接続中...'
  },
  __ChatBubbleAi: {
    answer_by_mrc: 'MRCによる回答',
    mrc_answer_desc: 'MRC（機械読解）はテキストドキュメントをスキャンし、テキストから意味を抽出します',
    answer_by_chatGPT: 'ChatGPTによる回答',
    chatgpt_answer_desc: 'ChatGPTは、OpenAIによって開発されたAIチャットボットで、自然言語処理を使用して人間のような会話を作成します。',
    prompt_bar_message: 'このコンテンツは役に立ちましたか？',
    comment_dialog: {
      title: '評価の理由を共有していただけますか？',
      yes: 'はい',
      no: 'いいえ',
      placeholder: 'ここにコメントを書いてください',
      remaining_character: '残りの文字数: {0}/{1}',
      submit: '送信',
      closing: 'コメントありがとうございます！'
    }
  }
}
